// Module système : Bannière d'annonces
import React from 'react';
import { useSystemModules } from '../../G&CSCM/Core/SystemModulesContext';

const AnnouncementBanner: React.FC = () => {
    const { announcements, dismissAnnouncement } = useSystemModules();

    if (announcements.length === 0) {
        return null;
    }

    // Trier par priorité (plus haute d'abord)
    const sortedAnnouncements = [...announcements].sort((a, b) => b.priority - a.priority);

    return (
        <div
            className="announcement-banner-container"
            style={{
                position: 'fixed',
                top: '70px', // En dessous de la bannière API si présente
                left: 0,
                right: 0,
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                gap: '0'
            }}
        >
            {sortedAnnouncements.map(announcement => {
                const colors = {
                    info: { bg: '#2196F3', icon: 'ℹ️' },
                    warning: { bg: '#ff9800', icon: '⚠️' },
                    success: { bg: '#4CAF50', icon: '✅' }
                };

                const style = colors[announcement.type];

                return (
                    <div
                        key={announcement.id}
                        className="announcement-banner-item"
                        style={{
                            backgroundColor: style.bg,
                            color: 'white',
                            padding: '12px 20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            fontFamily: 'system-ui, sans-serif'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <span style={{ fontSize: '18px' }}>{style.icon}</span>
                            <p style={{ margin: 0, fontSize: '14px' }}>
                                {announcement.message}
                            </p>
                        </div>
                        {announcement.dismissible && (
                            <button
                                onClick={() => dismissAnnouncement(announcement.id)}
                                style={{
                                    background: 'rgba(255,255,255,0.2)',
                                    border: 'none',
                                    color: 'white',
                                    padding: '6px 12px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px'
                                }}
                            >
                                Fermer
                            </button>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default AnnouncementBanner;


